import { Component } from '@angular/core';
import { AbstractModalWithResult } from 'src/app/shared/components/abstract-modal-with-result';

@Component({
  templateUrl: './delete-message-in-task-process-popover.component.html',
  styleUrls: ['delete-message-in-task-process-popover.component.scss'],
})
export class DeleteMessageInTaskProcessComponent extends AbstractModalWithResult<void> {
  static modalId = 'DeleteMessageInTaskProcessComponent';

  getModalId() {
    return DeleteMessageInTaskProcessComponent.modalId;
  }
}
